[
  ["ac", "1T", "1T", "International - E. 14th", "782B84"],
  ["ac", "6", "6", "Berkeley - Telegraph - Oakland", "A30D11"],
  ["ac", "7", "7", "Arlington - Shattuck - Stanford", "07B5D0"],
  ["ac", "9", "9", "E. 14th St. - Mission", "A30D11"],
  ["ac", "12", "12", "MLK Jr. - Temescal - Grand", "2B589C"],
  ["ac", "14", "14", "14th St - San Antonio - High St", "2B589C"],
  ["ac", "18", "18", "Solano - Shattuck - Park Blvd.", "A30D11"],
  ["ac", "19", "19", "Alameda Pt-Buena Vista-Fruitvale", "07B5D0"],
  ["ac", "22", "22", "Alcatraz - Peralta - Lakeshore", "2B589C"],
  ["ac", "27", "27", "EMY Amtrak-Ashby-El Cerrito Plz.", "2B589C"],
  ["ac", "28", "28", "Alvarado - Castro Valley - B St.", "07B5D0"],
  ["ac", "30", "30", "Dimond - Fruitvale - South Shore", "2B589C"],
  ["ac", "31", "31", "Skyline Blvd-Fruitvale-Bay Farm", "2B589C"],
  ["ac", "34", "34", "Estudillo - Davis - Meekland", "07B5D0"],
  ["ac", "35", "35", "Estudillo - Davis -  Lewelling", "07B5D0"],
  ["ac", "36", "36", "Claremont - Dwight - Adeline", "2B589C"],
  ["ac", "40", "40", "Foothill - Bancroft - Bay Fair", "A30D11"],
  ["ac", "41", "41", "Whitman - Huntwood - Union Landg", "07B5D0"],
  ["ac", "45", "45", "Seminary - Sobrante Park", "2B589C"],
  ["ac", "46L", "46L", "82nd Ave. - Grass Valley Limited", "07B5D0"],
  ["ac", "51A", "51A", "Broadway - Santa Clara", "A30D11"],
  ["ac", "51B", "51B", "University - College - Rockridge", "A30D11"],
  ["ac", "52", "52", "UC Village - Cedar - UC Campus", "A30D11"],
  ["ac", "54", "54", "35th Ave. - Merritt College", "2B589C"],
  ["ac", "56", "56", "Santa Clara - Weekes - Huntwood", "07B5D0"],
  ["ac", "57", "57", "40th St. - MacArthur", "A30D11"],
  ["ac", "60", "60", "CSUEB - Southland - Tennyson", "07B5D0"],
  ["ac", "62", "62", "7th St. - San Antonio - 23rd Av.", "2B589C"],
  ["ac", "65", "65", "Grizzly Peak - Euclid", "07B5D0"],
  ["ac", "67", "67", "Spruce - Oxford", "07B5D0"],
  ["ac", "70", "70", "Rheem - San Pablo Dam - Appian", "2B589C"],
  ["ac", "71", "71", "Parchester - Rumrill - Carlson", "2B589C"],
  ["ac", "72", "72", "CCC - San Pablo", "2B589C"],
  ["ac", "72L", "72L", "San Pablo Limited", "2B589C"],
  ["ac", "72M", "72M", "Macdonald - San Pablo", "2B589C"],
  ["ac", "73", "73", "73rd Ave. - Coliseum - Airport", "2B589C"],
  ["ac", "74", "74", "San Pablo Dam - 23rd St.", "2B589C"],
  ["ac", "76", "76", "Cutting - Market - Moyers", "2B589C"],
  ["ac", "86", "86", "Winton - Industrial - Tennyson", "07B5D0"],
  ["ac", "88", "88", "Sacramento - Market- Oakland Ave", "2B589C"],
  ["ac", "90", "90", "85th Ave. - Elmhurst - 90th Ave.", "2B589C"],
  ["ac", "93", "93", "Ashland - San Lorenzo - A St.", "07B5D0"],
  ["ac", "95", "95", "D St. - Maud - Fairview", "07B5D0"],
  ["ac", "96", "96", "Alameda Pt. - 14th Ave. - Dimond", "2B589C"],
  ["ac", "97", "97", "Hesperian - Alvarado - Decoto", "2B589C"],
  ["ac", "98", "98", "Eastmont - 98th Ave. - Edgewater", "2B589C"],
  ["ac", "200", "200", "Decoto - Newark Blvd. - Mowry", "2B589C"],
  ["ac", "210", "210", "Fremont Blvd. - Mission San Jose", "2B589C"],
  ["ac", "211", "211", "Fremont Blvd-Walnut Ave-Mission", "2B589C"],
  ["ac", "216", "216", "Niles - Stevenson - NewPark", "07B5D0"],
  ["ac", "231", "231", "Fremont Blvd-Warm Springs-Milpa.", "07B5D0"],
  ["ac", "239", "239", "Pacific Cm.-Grimmer-Warm Springs", "2B589C"],
  ["ac", "251", "251", "Paseo Padre - Thornton - Cherry", "07B5D0"],
  ["ac", "281", "281", "Decoto - Paseo Padre-Cedar Blvd", "07B5D0"],
  ["ac", "604", "604", "Head Royce - OHDS - Berkeley", "000000"],
  ["ac", "605", "605", "Head Royce - Montclair - College", "000000"],
  ["ac", "606", "606", "Head Royce - Piedmont", "000000"],
  ["ac", "607", "607", "Richmond High - Point Richmond", "000000"],
  ["ac", "617", "617", "Skyline High - Seminary", "000000"],
  ["ac", "620", "620", "Newark Middle - Cedar", "595959"],
  ["ac", "621", "621", "American High - Thornton Middle", "000000"],
  ["ac", "623", "623", "Irvington High - Horner Middle", "000000"],
  ["ac", "624", "624", "Mission San Jose - Hopkins Mid", "000000"],
  ["ac", "625", "625", "Washington - Centerville Middle", "000000"],
  ["ac", "627", "627", "Newark Memorial-Cedar-Newark Bl.", "595959"],
  ["ac", "629", "629", "Newark Memorial - Cherry - Haley", "595959"],
  ["ac", "631", "631", "Encinal - Alameda - Bay Farm", "000000"],
  ["ac", "633", "633", "Harrison - Broadway - Park Blvd.", "000000"],
  ["ac", "638", "638", "Skyline High - 73rd Ave.", "000000"],
  ["ac", "639", "639", "Skyline High - Fruitvale Ave.", "000000"],
  ["ac", "641", "641", "Hopkins Middle - Mission Blvd", "000000"],
  ["ac", "642", "642", "Montera - Montclair - Colton", "000000"],
  ["ac", "646", "646", "Montera - Skyline - 82nd Ave.", "000000"],
  ["ac", "648", "648", "Skyline - High St.", "000000"],
  ["ac", "649", "649", "Montera - Skyline - Grass Valley", "000000"],
  ["ac", "650", "650", "Montera - Oakmore - Seminary", "000000"],
  ["ac", "651", "651", "Oakland Tech - Downtown Oakland", "000000"],
  ["ac", "652", "652", "Skyline High - Elmhurst", "000000"],
  ["ac", "653", "653", "Montera - MacArthur", "000000"],
  ["ac", "654", "654", "Skyline High - 35th Ave.", "000000"],
  ["ac", "655", "655", "Montera - 35th Ave.", "000000"],
  ["ac", "657", "657", "Oak High - Oak Tech - MacArthur", "000000"],
  ["ac", "658", "658", "Skyline - Bret Harte - MacArthur", "000000"],
  ["ac", "660", "660", "Montera - Broadway Terrace", "000000"],
  ["ac", "662", "662", "Skyline High - Broadway Terrace", "000000"],
  ["ac", "663", "663", "Encinal - South Shore - High St.", "000000"],
  ["ac", "667", "667", "Korematsu - E.C. - No. Richmond", "000000"],
  ["ac", "669", "669", "Soskin Middle - San Pablo Dam", "000000"],
  ["ac", "675", "675", "Korematsu - El Cerrito - Carlson", "000000"],
  ["ac", "677", "677", "Montera - Broadway Terrace", "000000"],
  ["ac", "678", "678", "De Anza - Soskin - Fairmede", "000000"],
  ["ac", "680", "680", "Bishop O'Dowd High - MacArthur", "000000"],
  ["ac", "681", "681", "DeJean - Cutting - Macdonald", "000000"],
  ["ac", "682", "682", "Bishop O'Dowd High - Montclair", "000000"],
  ["ac", "683", "683", "Montclair - Bishop O'Dowd High", "000000"],
  ["ac", "684", "684", "El Cerrito - Arlington - Garvin", "000000"],
  ["ac", "687", "687", "Lincoln Middle - Bay Farm", "000000"],
  ["ac", "688", "688", "St. Mary's College - Montclair", "000000"],
  ["ac", "689", "689", "De Anza - Soskin - CC College", "000000"],
  ["ac", "696", "696", "Oakland Tech - Montclair", "000000"],
  ["ac", "701", "701", "Pittsburg/BP Transbay Early Bird", "492F92"],
  ["ac", "702", "702", "Pleas Hill Transbay Early Bird", "492F92"],
  ["ac", "703", "703", "Dubl/Plsntn Transbay Early Bird", "492F92"],
  ["ac", "800", "800", "Rich - Oak Transbay All Nighter", "BC8E2D"],
  ["ac", "801", "801", "E 14th - Mission  All Nighter", "BC8E2D"],
  ["ac", "802", "802", "San Pablo All Nighter", "BC8E2D"],
  ["ac", "805", "805", "MacArthur - Airport All Nighter", "BC8E2D"],
  ["ac", "840", "840", "Foothill - Eastmont All Nighter", "BC8E2D"],
  ["ac", "851", "851", "Santa Clara-Broadway All Nighter", "BC8E2D"],
  ["ac", "E", "E", "Tunnel Rd. - Claremont Transbay", "BC8E2D"],
  ["ac", "F", "F", "Adeline - Market Transbay", "2B589C"],
  ["ac", "FS", "FS", "Shattuck - University Transbay", "BC8E2D"],
  ["ac", "G", "G", "Colusa - Solano Transbay", "BC8E2D"],
  ["ac", "J", "J", "Sacramento -  Christie Transbay", "BC8E2D"],
  ["ac", "L", "L", "San Pablo - Pierce Transbay", "BC8E2D"],
  ["ac", "NL", "NL", "MacArthur Transbay Limited", "2B589C"],
  ["ac", "NX", "NX", "Grand Lake - Laurel  Transbay", "BC8E2D"],
  ["ac", "NX3", "NX3", "MacArthur - Eastmont Transbay", "BC8E2D"],
  ["ac", "O", "O", "Santa Clara - Encinal Transbay", "2B589C"],
  ["ac", "P", "P", "Piedmont - Oakland Ave. Transbay", "BC8E2D"],
  ["ac", "U", "U", "Stanford - Dumbarton - Fremont", "BC8E2D"],
  ["ac", "V", "V", "Montclair - Park Blvd. Transbay", "BC8E2D"],
  ["ac", "W", "W", "Bay Farm - South Shore Transbay", "BC8E2D"],
  ["airport", "Lot D", "Lot D", "Parking Lot D Shuttle Bus", ""],
  ["airport", "West Field Garage", "West Field Garage", "West Field Garage Shuttle Bus", ""],
  ["capitol-bus", "SF", "SF", "Shuttle_SF", ""],
  ["capitol-bus", "Shuttle", "Shuttle", "Shuttle_Auburn", ""],
  ["commute", "BAY Shuttle", "BAY Shuttle", "Burlingame Bayside", "5b91cc"],
  ["commute", "BCP Shuttle", "BCP Shuttle", "Brisbane Crocker Park", "5b91cc"],
  ["commute", "BPT Shuttle", "BPT Shuttle", "Burlingame Point", "5b91cc"],
  ["commute", "DCB Shuttle", "DCB Shuttle", "Daly City Bayshore", "00fd9a"],
  ["commute", "FCC Shuttle", "FCC Shuttle", "Foster City Commuter", "00befd"],
  ["commute", "HCC Shuttle", "HCC Shuttle", "Hillsdale Caltrain Commuter", "00befd"],
  ["commute", "M1 Shuttle", "M1 Shuttle", "Crosstown", "008cfd"],
  ["commute", "M3 Shuttle", "M3 Shuttle", "Marsh Road", "c187ee"],
  ["commute", "M4 Shuttle", "M4 Shuttle", "Willow Road", "eaeb0e"],
  ["commute", "MBC Shuttle", "MBC Shuttle", "Millbrae Burlingame Commuter", "00befd"],
  ["commute", "MPT Shuttle", "MPT Shuttle", "Redwood City Midpoint", "5b91cc"],
  ["commute", "NFC Shuttle", "NFC Shuttle", "North Foster City", "5b91cc"],
  ["commute", "OPB Shuttle", "OPB Shuttle", "Oyster Point BART", "5b91cc"],
  ["commute", "OPC Shuttle", "OPC Shuttle", "Oyster Point Caltrain", "5b91cc"],
  ["commute", "OPF Shuttle", "OPF Shuttle", "Oyster Point Ferry", "5b91cc"],
  ["commute", "RLC Shuttle", "RLC Shuttle", "Redwood LIFE Caltrain", "5b91cc"],
  ["commute", "SEA Shuttle", "SEA Shuttle", "Seaport Centre", "5b91cc"],
  ["commute", "SKY Shuttle", "SKY Shuttle", "Skyline College Express", "00befd"],
  ["commute", "UGB Shuttle", "UGB Shuttle", "Utah-Grand BART", "5b91cc"],
  ["commute", "UGC Shuttle", "UGC Shuttle", "Utah-Grand Caltrain", "5b91cc"],
  ["county", "1", "1", "Rossmoor/Shadelands", "006493"],
  ["county", "4", "4", "Walnut Creek BART/Broadway Plaza", "46A076"],
  ["county", "5", "5", "Walnut Creek BART/Creekside Dr", "46A076"],
  ["county", "6", "6", "Lafayette BART/Orinda BART", "006493"],
  ["county", "7", "7", "Pleasant Hill BART/Shadelands", "46A076"],
  ["county", "9", "9", "DVC/Walnut Creek BART", "006493"],
  ["county", "10", "10", "Concord BART/Clayton Rd", "006493"],
  ["county", "11", "11", "Concord BART/Pleasant Hill BART", "46A076"],
  ["county", "14", "14", "Concord BART/Walnut Creek BART", "46A076"],
  ["county", "15", "15", "Concord BART/Pleasant Hill BART", "006493"],
  ["county", "16", "16", "Martinez Amtrak/Concord BART", "46A076"],
  ["county", "17", "17", "Concord BART/North Concord BART", "006493"],
  ["county", "18", "18", "Martinez Amtrak/Pleasant Hill BART", "006493"],
  ["county", "19", "19", "Martinez Amtrak/Concord BART", "006493"],
  ["county", "20", "20", "DVC/Concord BART", "006493"],
  ["county", "21", "21", "Walnut Creek BART/San Ramon", "006493"],
  ["county", "28", "28", "Concord BART/Amtrak", "006493"],
  ["county", "35", "35", "Dublin/Pleasanton BART/San Ramon", "006493"],
  ["county", "91X", "91X", "Concord Commuter Express", "DE9634"],
  ["county", "92X", "92X", "Pleasanton ACE/Mitchell Dr", "DE9634"],
  ["county", "93X", "93X", "Walnut Creek BART/Antioch BART", "DE9634"],
  ["county", "95X", "95X", "San Ramon/BART Walnut Creek", "DE9634"],
  ["county", "96X", "96X", "BART Walnut Creek/Bishop Ranch", "DE9634"],
  ["county", "97X", "97X", "Dublin BART/Bishop Ranch", "DE9634"],
  ["county", "98X", "98X", "Martinez Amtrak/Walnut Creek BART", "DE9634"],
  ["county", "99X", "99X", "Martinez Amtrak/North Concord BART", "46A076"],
  ["county", "301", "301", "Walnut Creek BART/N Via Monte", "9C629D"],
  ["county", "310", "310", "Concord BART/Clayton Rd", "9C629D"],
  ["county", "311", "311", "Concord BART/Walnut Creek BART", "46A076"],
  ["county", "314", "314", "Concord BART/DVC", "46A076"],
  ["county", "315", "315", "Concord BART/Bel Air Dr", "9C629D"],
  ["county", "316", "316", "Martinez Amtrak/Pleasant Hill BART", "46A076"],
  ["county", "320", "320", "DVC/Concord BART", "9C629D"],
  ["county", "321", "321", "Walnut Creek BART/San Ramon", "9C629D"],
  ["county", "335", "335", "Dublin BART/San Ramon", "9C629D"],
  ["county", "601", "601", "Rossmoor/WCI", "7A99AC"],
  ["county", "602", "602", "Walnut Blvd/WCI", "7A99AC"],
  ["county", "605", "605", "Creekside/WCI", "7A99AC"],
  ["county", "606", "606", "Miramonte High/OIS/Orinda BART", "7A99AC"],
  ["county", "611", "611", "Oak Grove Middle/Concord BART", "7A99AC"],
  ["county", "612", "612", "Pine Hollow Middle/Concord BART", "7A99AC"],
  ["county", "613", "613", "Oak Grove Middle/Concord BART", "7A99AC"],
  ["county", "615", "615", "Concord High/El Dorado/Concord BART", "7A99AC"],
  ["county", "616", "616", "Oak Grove Middle/Concord BART", "7A99AC"],
  ["county", "619", "619", "Oak Grove Middle/Pleasant Hill BART", "7A99AC"],
  ["county", "622", "622", "Cal High/Pine Valley Middle", "7A99AC"],
  ["county", "623", "623", "Monte Vista High/Annabel", "7A99AC"],
  ["county", "625", "625", "Acalanes High/Lafayette BART", "7A99AC"],
  ["county", "626", "626", "Saint Mary's College/Lafayette BART", "7A99AC"],
  ["county", "635", "635", "Bollinger Canyon/Camino Tassajara", "7A99AC"],
  ["county", "636", "636", "Broadmoor/Dublin/Pleasanton BART", "7A99AC"],
  ["dumbarton", "DB", "DB", "Dumbarton Exp. - Palo Alto", ""],
  ["dumbarton", "DB1", "DB1", "Dumbarton Exp. - Research Park", ""],
  ["emery", "Hollis", "Hollis", "Hollis", "F10909"],
  ["emery", "Hollis/Holi", "Hollis/Holi", "Hollis Holiday", "F10909"],
  ["emery", "Shell/Pow", "Shell/Pow", "Shellmound/Powell WD", "7A219E"],
  ["emery", "Shell/Pow Sat", "Shell/Pow Sat", "Shellmound/Powell Sat", "A149D0"],
  ["emery", "Shell/Pow Sun", "Shell/Pow Sun", "Shellmound/Powell Sun", "AF55D8"],
  ["emery-express", "EmExp", "EmExp", "The Emery Express", ""],
  ["fast", "1", "1", "FTC/Fairfield Walmart", "5587b3"],
  ["fast", "3", "3", "FTC/Solano Town Center/Fairfield Walmart", "aa3942"],
  ["fast", "6", "6", "Solano Town Center/East Tabor & Sunset", "2b579a"],
  ["fast", "7", "7", "FTC/Solano College/Cordelia Library", "c06b3f"],
  ["fast", "8T", "8T", "Cordelia School Tripper", "ae6fcf"],
  ["golden-gate", "101", "101", "Novato - San Francisco", "3366FF"],
  ["golden-gate", "114", "114", "Mill Valley - San Francisco", "CC3333"],
  ["golden-gate", "120", "120", "Strawberry - San Francisco", "3366FF"],
  ["golden-gate", "132", "132", "San Anselmo - San Francisco", "CC3333"],
  ["golden-gate", "154", "154", "Novato - San Francisco", "CC3333"],
  ["golden-gate", "172", "172", "Santa Rosa - San Francisco", "CC3333"],
  ["golden-gate", "172X", "172X", "Santa Rosa - San Francisco Express", "CC3333"],
  ["golden-gate", "580", "580", "Del Norte BART Station - San Rafael", "3366FF"],
  ["golden-gate", "580X", "580X", "Del Norte BART Station - San Rafael Express", "3366FF"],
  ["golden-gate", "704", "704", "Del Norte BART Station - San Francisco", "CC3333"],
  ["links", "North", "North", "North Loop", "1D4071"],
  ["links", "South", "South", "South Loop", "109246"],
  ["marin", "17", "17", "Downtown San Rafael - Sausalito", "1b65ac"],
  ["marin", "22", "22", "Downtown San Rafael - Marin City", "a02125"],
  ["marin", "23", "23", "Canal - Fairfax Manor", "c90b86"],
  ["marin", "30", "30", "Canal - Downtown San Rafael", "812990"],
  ["marin", "35", "35", "Canal - Northgate", "00aeef"],
  ["marin", "36", "36", "Canal - Marin City", "e6b00d"],
  ["marin", "49", "49", "Downtown San Rafael - Novato San Marin", "0089d0"],
  ["marin", "57", "57", "Downtown San Rafael - Novato", "76a33a"],
  ["marin", "61", "61", "Sausalito - Bolinas", "5567a9"],
  ["marin", "68", "68", "Downtown San Rafael - Inverness", "5567a9"],
  ["marin", "71", "71", "Novato - Marin City", "f57d20"],
  ["marin", "219", "219", "Tiburon - Strawberry", "008a5d"],
  ["marin", "228", "228", "Downtown San Rafael - Fairfax Manor", "00b26a"],
  ["marin", "233", "233", "San Rafael (Downtown - Santa Venetia)", "005a23"],
  ["marin", "245", "245", "San Rafael (Downtown - Smith Ranch Road)", "009649"],
  ["marin", "613", "613", "Paradise Cay - Redwood HS", "515553"],
  ["marin", "619", "619", "Tiburon - Redwood HS", "515553"],
  ["marin", "625", "625", "Lagunitas - Sir Francis Drake HS - San Anselmo Hub", "515553"],
  ["marin", "629", "629", "Paradise Cay - Hall MS", "515553"],
  ["marin", "654", "654", "Olive - Novato Loop", "515553"],
  ["mission-bay", "CCA/Adobe", "CCA/Adobe", "", "b7702a"],
  ["mission-bay", "East", "East", "", "2074dd"],
  ["mission-bay", "TC", "TC", "Transbay-Caltrain", "f15a29"],
  ["mission-bay", "West", "West", "", "548433"],
  ["mountain-view", "GRAY", "GRAY", "Gray", "8C8C88"],
  ["mountain-view", "GRAY WE", "GRAY WE", "Gray Weekend", "8C8C88"],
  ["mountain-view", "RED", "RED", "Red", "FF2B0A"],
  ["mountain-view", "RED WE", "RED WE", "Red Weekend", "FF2B0A"],
  ["muni-bus", "1", "1", "CALIFORNIA", "005B95"],
  ["muni-bus", "1X", "1X", "CALIFORNIA EXPRESS", "BF2B45"],
  ["muni-bus", "2", "2", "SUTTER", "005B95"],
  ["muni-bus", "5", "5", "FULTON", "005B95"],
  ["muni-bus", "5R", "5R", "FULTON RAPID", "BF2B45"],
  ["muni-bus", "6", "6", "HAYES-PARNASSUS", "005B95"],
  ["muni-bus", "7", "7", "HAIGHT-NORIEGA", "005B95"],
  ["muni-bus", "8", "8", "BAYSHORE", "005B95"],
  ["muni-bus", "8AX", "8AX", "BAYSHORE A EXPRESS", "005B95"],
  ["muni-bus", "8BX", "8BX", "BAYSHORE B EXPRESS", "005B95"],
  ["muni-bus", "9", "9", "SAN BRUNO", "005B95"],
  ["muni-bus", "9R", "9R", "SAN BRUNO RAPID", "BF2B45"],
  ["muni-bus", "12", "12", "FOLSOM-PACIFIC", "005B95"],
  ["muni-bus", "14", "14", "MISSION", "005B95"],
  ["muni-bus", "14R", "14R", "MISSION RAPID", "BF2B45"],
  ["muni-bus", "15", "15", "BAYVIEW HUNTERS POINT EXPRESS", "005B95"],
  ["muni-bus", "18", "18", "46TH AVENUE", "005B95"],
  ["muni-bus", "19", "19", "POLK", "005B95"],
  ["muni-bus", "22", "22", "FILLMORE", "005B95"],
  ["muni-bus", "23", "23", "MONTEREY", "005B95"],
  ["muni-bus", "24", "24", "DIVISADERO", "005B95"],
  ["muni-bus", "25", "25", "TREASURE ISLAND", "005B95"],
  ["muni-bus", "27", "27", "BRYANT", "005B95"],
  ["muni-bus", "28", "28", "19TH AVENUE", "005B95"],
  ["muni-bus", "28R", "28R", "19TH AVENUE RAPID", "BF2B45"],
  ["muni-bus", "29", "29", "SUNSET", "005B95"],
  ["muni-bus", "30", "30", "STOCKTON", "005B95"],
  ["muni-bus", "30X", "30X", "MARINA EXPRESS", "005B95"],
  ["muni-bus", "31", "31", "BALBOA", "005B95"],
  ["muni-bus", "33", "33", "ASHBURY-18TH ST", "005B95"],
  ["muni-bus", "35", "35", "EUREKA", "005B95"],
  ["muni-bus", "36", "36", "TERESITA", "005B95"],
  ["muni-bus", "37", "37", "CORBETT", "005B95"],
  ["muni-bus", "38", "38", "GEARY", "005B95"],
  ["muni-bus", "38R", "38R", "GEARY RAPID", "BF2B45"],
  ["muni-bus", "39", "39", "COIT", "005B95"],
  ["muni-bus", "43", "43", "MASONIC", "005B95"],
  ["muni-bus", "44", "44", "O'SHAUGHNESSY", "005B95"],
  ["muni-bus", "45", "45", "UNION-STOCKTON", "005B95"],
  ["muni-bus", "48", "48", "QUINTARA-24TH STREET", "005B95"],
  ["muni-bus", "49", "49", "VAN NESS-MISSION", "005B95"],
  ["muni-bus", "52", "52", "EXCELSIOR", "005B95"],
  ["muni-bus", "54", "54", "FELTON", "005B95"],
  ["muni-bus", "55", "55", "DOGPATCH", "005B95"],
  ["muni-bus", "56", "56", "RUTLAND", "005B95"],
  ["muni-bus", "57", "57", "PARKMERCED", "005B95"],
  ["muni-bus", "58", "58", "LAKE MERCED", "005B95"],
  ["muni-bus", "66", "66", "QUINTARA", "005B95"],
  ["muni-bus", "67", "67", "BERNAL HEIGHTS", "005B95"],
  ["muni-bus", "90", "90", "SAN BRUNO OWL", "666666"],
  ["muni-bus", "91", "91", "3RD-19TH AVE OWL", "666666"],
  ["muni-bus", "714", "714", "BART EARLY BIRD", "005B95"],
  ["muni-bus", "FBUS", "FBUS", "MARKET & WHARVES BUS", "B49A36"],
  ["muni-bus", "KBUS", "KBUS", "INGLESIDE BUS", "437C93"],
  ["muni-bus", "LOWL", "LOWL", "OWL TARAVAL", "666666"],
  ["muni-bus", "NBUS", "NBUS", "JUDAH BUS", "005B95"],
  ["muni-bus", "NOWL", "NOWL", "OWL JUDAH", "666666"],
  ["muni-bus", "TBUS", "TBUS", "THIRD BUS", "BF2B45"],
  ["mvgo", "A - AM", "A - AM", "Whisman, Clyde & Middlefield", "1F51FF"],
  ["mvgo", "A - PM", "A - PM", "Middlefield, Clyde & Whisman", "1F51FF"],
  ["mvgo", "B - AM", "B - AM", "Shoreline, La Avenida, Crittenden", "E08926"],
  ["mvgo", "B - PM", "B - PM", "Shoreline, Crittenden, La Avenida", "E08926"],
  ["mvgo", "B - PM Concert", "B - PM Concert", "Shoreline, Crittenden, La Avenida - Concert", "E08926"],
  ["mvgo", "C - AM", "C - AM", "Charleston, Garcia & San Antonio (Counterclockwise loop)", "43B5AE"],
  ["mvgo", "C - PM", "C - PM", "Charleston, Garcia & San Antonio (Counterclockwise loop)", "43B5AE"],
  ["mvgo", "D - AM", "D - AM", "San Antonio, Garcia & Charleston (Clockwise loop)", "FDDD00"],
  ["mvgo", "D - PM", "D - PM", "San Antonio, Garcia & Charleston (Clockwise loop)", "FDDD00"],
  ["mvgo", "D - PM Concert", "D - PM Concert", "San Antonio, Garcia & Charleston (Clockwise loop) - Concert", "FDDD00"],
  ["park", "GGPS", "GGPS", "Golden Gate Park Shuttle", "2a1589"],
  ["petaluma", "2", "2", "02 N. Mcdowell", "D1232F"],
  ["petaluma", "3", "3", "03 Eastside Clockwise", "00AAEB"],
  ["petaluma", "10", "10", "10 Petaluma Blvd", "B53B2C"],
  ["petaluma", "11", "11", "11 Petaluma Crosstown", "763491"],
  ["petaluma", "24", "24", "24 SMART - Lakeville -Kaiser Hospital", "F7911D"],
  ["petaluma", "33", "33", "33 Eastside Counter-Clock", "293F8B"],
  ["petaluma", "301", "301", "301 KJHS/CGHS AM", "5CCC87"],
  ["petaluma", "302", "302", "302 KJHS/CGHS McDwoell", "B65093"],
  ["petaluma", "303", "303", "303 KJHS/CGHS", "005C66"],
  ["petaluma", "311", "311", "311 Casa Grande High and Kenilworth Junior High", "F25C4D"],
  ["petaluma", "501", "501", "501 Petaluma High and Junior High", "9E003A"],
  ["presidio", "Presidio GO Downtown", "Presidio GO Downtown", "Presidio GO Downtown", "EA321B"],
  ["presidio", "Presidio GO South Hills", "Presidio GO South Hills", "Presidio GO South Hills", "228B22"],
  ["rio-vista", "50", "50", "Fairfield – Rio Vista", "ccd7e8"],
  ["samtrans", "10", "10", "Daly City BART - Terra Nova HS", ""],
  ["samtrans", "12", "12", "Pacifica School - Fairmont Shopping Center", ""],
  ["samtrans", "14", "14", "Linda Mar Circulator", ""],
  ["samtrans", "15", "15", "HMBHS - Moonridge Apts", ""],
  ["samtrans", "18", "18", "Main/7th - HMBHS", ""],
  ["samtrans", "19", "19", "Lacy School - Linda Mar Park & Ride", ""],
  ["samtrans", "24", "24", "Brisbane - Shasta High", ""],
  ["samtrans", "25", "25", "Los Olivos/Santa Barbara - Ben Franklin School", ""],
  ["samtrans", "28", "28", "Serramonte Center - South City High", ""],
  ["samtrans", "29", "29", "Lipman School - Templeton/Brunswick", ""],
  ["samtrans", "30", "30", "Daly City BART - Price/East Market", ""],
  ["samtrans", "35", "35", "El Camino High - Warwick/Christen", ""],
  ["samtrans", "37", "37", "Hillside/Grove - Alta Loma School", ""],
  ["samtrans", "40", "40", "IBL  Middle School - San Bruno BART", ""],
  ["samtrans", "41", "41", "Parkside IL - San Bruno BART", ""],
  ["samtrans", "42", "42", "Pacifica - Parkside IL", ""],
  ["samtrans", "46", "46", "Burlingame School - Carolan (Burlingame Caltrain)", ""],
  ["samtrans", "49", "49", "Brisbane - Terra Nova High", ""],
  ["samtrans", "50", "50", "Bay STEM Academy - Hillsdale Shopping Center", ""],
  ["samtrans", "51", "51", "Foster City - Hillsdale HS", ""],
  ["samtrans", "53", "53", "Peninsula/Humboldt - Borel MS", ""],
  ["samtrans", "53P", "53P", "Peninsula/Humboldt - Borel MS via Poplar", ""],
  ["samtrans", "54", "54", "Bowditch School - Hillsdale/Norfolk", ""],
  ["samtrans", "56", "56", "Aragon HS - Polhemus/Paul Scannell", ""],
  ["samtrans", "57", "57", "Edgewater/Beach Park - Hillsdale High", ""],
  ["samtrans", "58", "58", "Borel School - Polhemus/Paul Scannell", ""],
  ["samtrans", "59", "59", "Hillsdale/Norfolk - Aragon High", ""],
  ["samtrans", "60", "60", "Ralston School - Bridge/Bowsprit via Chula Vista", ""],
  ["samtrans", "61", "61", "San Carlos Caltrain - Alameda/Ralston", ""],
  ["samtrans", "62", "62", "Hillsdale - Alameda & Ralston", ""],
  ["samtrans", "67", "67", "Bridge/Bowsprit - Ralston School", ""],
  ["samtrans", "68", "68", "Hiller/Wessex - Ralston School", ""],
  ["samtrans", "72", "72", "Marlborough/Dumbarton - Selby Lane School", ""],
  ["samtrans", "73", "73", "G & Industrial - Clifford School", ""],
  ["samtrans", "78", "78", "Emerald Hills - Woodside HS", ""],
  ["samtrans", "79", "79", "Kennedy MS - Florence/17th", ""],
  ["samtrans", "81", "81", "MAHS - East Palo Alto", ""],
  ["samtrans", "82", "82", "Bay/Marsh - Hillview School", ""],
  ["samtrans", "83", "83", "Hillview School - Bay/Marsh", ""],
  ["samtrans", "85", "85", "Ormondale School - La Honda/Grandview", ""],
  ["samtrans", "86", "86", "Sharon Heights - Menlo-Atherton High School", ""],
  ["samtrans", "87", "87", "Woodside High - Portola Valley", ""],
  ["samtrans", "88", "88", "Bay/Marsh - Encinal School", ""],
  ["samtrans", "110", "110", "Daly City BART - Linda Mar Park & Ride", ""],
  ["samtrans", "112", "112", "Sharp Park - Colma BART", ""],
  ["samtrans", "117", "117", "Linda Mar Park & Ride - Moonridge Apts", ""],
  ["samtrans", "120", "120", "Colma BART - Brunswick/Templeton", ""],
  ["samtrans", "121", "121", "Pope/Bellevue - Skyline College", ""],
  ["samtrans", "122", "122", "South SF BART - Stonestown/SF State", ""],
  ["samtrans", "130", "130", "Daly City BART - Airport & Linden/Oyster Point", ""],
  ["samtrans", "138", "138", "Safe Harbor Shelter", ""],
  ["samtrans", "141", "141", "Airport/Linden - Skyline College", ""],
  ["samtrans", "142", "142", "SFO - Shelter Creek", ""],
  ["samtrans", "250", "250", "Downtown San Mateo - College of San Mateo", ""],
  ["samtrans", "251", "251", "Foster City - Hillsdale Mall", ""],
  ["samtrans", "260", "260", "San Carlos Caltrain - Carlmont Village", ""],
  ["samtrans", "270", "270", "Redwood City Caltrain - Florence/17th loop", ""],
  ["samtrans", "276", "276", "Redwood City Transit Ctr - Bohannon/Campbell", ""],
  ["samtrans", "278", "278", "Redwood City Caltrain - Canada College", ""],
  ["samtrans", "280", "280", "Purdue/Fordham - Palo Alto Transit Ctr", ""],
  ["samtrans", "281", "281", "Belle Haven Community Campus - Stanford", ""],
  ["samtrans", "292", "292", "San Francisco - SFO - Hillsdale Mall", ""],
  ["samtrans", "294", "294", "Hillsdale - Half Moon Bay", ""],
  ["samtrans", "295", "295", "Hillsdale Mall - Redwood City Transit Center", ""],
  ["samtrans", "296", "296", "Redwood City Transit Center - Bayshore/Donohoe", ""],
  ["samtrans", "296O", "296O", "Redwood City TC- Palo Alto TC", ""],
  ["samtrans", "397", "397", "San Francisco - Palo Alto Transit Ctr", ""],
  ["samtrans", "713", "713", "SF Transit Center - San Francisco International", ""],
  ["samtrans", "CSM", "CSM", "College of San Mateo - Downtown San Mateo", ""],
  ["samtrans", "ECR", "ECR", "Daly City BART - Palo Alto Transit Ctr", ""],
  ["samtrans", "ECRO", "ECRO", "Daly City - SFO", ""],
  ["samtrans", "EPX", "EPX", "East Palo Alto - San Bruno BART and San Francisco", ""],
  ["samtrans", "FCX", "FCX", "Foster City - San Francisco", ""],
  ["samtrans", "PCX", "PCX", "Linda Mar Park & Ride - Daly City BART", ""],
  ["samtrans", "SKY", "SKY", "Daly City BART - Skyline College", ""],
  ["santa-cruz", "1", "1", "Soquel/Cabrillo/Airport", "003d6b"],
  ["santa-cruz", "2", "2", "Capitola/Cabrillo/Main", "003d6b"],
  ["santa-cruz", "2N", "2N", "Capitola/Cabrillo/Main", "003d6b"],
  ["santa-cruz", "3A", "3A", "Capitola Mall/Live Oak", "003d6b"],
  ["santa-cruz", "3B", "3B", "Capitola Mall/Live Oak", "003d6b"],
  ["santa-cruz", "4", "4", "River/Harvey West", "003d6b"],
  ["santa-cruz", "4W", "4W", "River/Harvey West", "003d6b"],
  ["santa-cruz", "11", "11", "UCSC via West Gate - High", "003d6b"],
  ["santa-cruz", "16", "16", "UCSC via Main Gate - Laurel/Bay", "003d6b"],
  ["santa-cruz", "17", "17", "Highway 17 Express", "ffce07"],
  ["santa-cruz", "18", "18", "UCSC via Main Gate - Mission", "003d6b"],
  ["santa-cruz", "19", "19", "UCSC via West Gate - Bay", "003d6b"],
  ["santa-cruz", "20", "20", "UCSC via Main Gate - Delaware", "003d6b"],
  ["santa-cruz", "34", "34", "Scotts Valley Drive/Emeline", "003d6b"],
  ["santa-cruz", "35", "35", "Highway 9/Scotts Valley", "003d6b"],
  ["santa-cruz", "35B", "35B", "Scotts Valley/Big Basin", "003d6b"],
  ["santa-cruz", "35X", "35X", "Santa Cruz/Boulder Creek Express", "003d6b"],
  ["santa-cruz", "40", "40", "Highway 1 - Davenport", "6c6e70"],
  ["santa-cruz", "41", "41", "Empire Grade - Bonny Doon", "6c6e70"],
  ["santa-cruz", "55", "55", "Cabrillo/Rio Del Mar/La Selva", "003d6b"],
  ["santa-cruz", "72", "72", "Green Valley - Pinto Lake", "003d6b"],
  ["santa-cruz", "72W", "72W", "Green Valley - Corralitos", "003d6b"],
  ["santa-cruz", "73", "73", "Soquel/Freedom/Cabrillo", "003d6b"],
  ["santa-cruz", "74S", "74S", "PVHS/Watsonville Hospital", "003d6b"],
  ["santa-cruz", "75", "75", "Green Valley - Wheelock", "003d6b"],
  ["santa-cruz", "78", "78", "Ohlone/Watsonville Hospital", "003d6b"],
  ["santa-cruz", "79", "79", "East Lake", "003d6b"],
  ["santa-cruz", "79F", "79F", "County Fair", "003d6b"],
  ["santa-rosa", "1", "1", "Mendocino Ave", "0074B3"],
  ["santa-rosa", "2", "2", "Sebastopol Rd and Corporate Center", "662D91"],
  ["santa-rosa", "2B", "2B", "Sebastopol Road", "952E91"],
  ["santa-rosa", "3", "3", "Santa Rosa Ave", "ED017F"],
  ["santa-rosa", "4", "4", "Rincon Valley Mission", "37A048"],
  ["santa-rosa", "4B", "4B", "Rincon Valley Hwy 12", "7FC34B"],
  ["santa-rosa", "5", "5", "Petaluma Hill Rd", "E8C01F"],
  ["santa-rosa", "6", "6", "Fulton Road", "B8093D"],
  ["santa-rosa", "8", "8", "Bennett Valley", "F26A2E"],
  ["santa-rosa", "9", "9", "West Ninth Street", "8094C4"],
  ["santa-rosa", "10", "10", "North City Connector", "F99F38"],
  ["santa-rosa", "12", "12", "Corby Ave and Roseland", "85BD3C"],
  ["santa-rosa", "15", "15", "Stony Point Road", "2FABCD"],
  ["santa-rosa", "16", "16", "Oakmont Shuttle", "9E4667"],
  ["santa-rosa", "18", "18", "East Circulator", "274867"],
  ["solano", "30D", "30D", "UC Davis Memorial Union", "d9ab28"],
  ["solano", "30S", "30S", "Sacramento", "824299"],
  ["soltrans", "1A", "1A", "West Clockwise", "592E91"],
  ["soltrans", "1B", "1B", "West Counterclockwise", "592E91"],
  ["soltrans", "3", "3", "South Vallejo", "50A140"],
  ["soltrans", "4", "4", "Tuolumne", "00A6CE"],
  ["soltrans", "6", "6", "Tennessee", "666EB3"],
  ["soltrans", "7A", "7A", "Clockwise", "004D91"],
  ["soltrans", "7B", "7B", "Counterclockwise", "004D91"],
  ["soltrans", "15", "15", "Rose", "A0CE60"],
  ["soltrans", "17", "17", "Hastings", "64B0E2"],
  ["soltrans", "38", "38", "Jesse Bethel", "C383B9"],
  ["soltrans", "40", "40", "Solano Concord", "004D91"],
  ["soltrans", "60", "60", "Solano El Cerrito del Norte", "D63029"],
  ["soltrans", "70", "70", "Benicia Concord", "FDB415"],
  ["soltrans", "82", "82", "SF Express", "F47B20"],
  ["soltrans", "90", "90", "Solano El Cerrito del Norte Express", "50A140"],
  ["sonoma", "10", "10", "10 - Cotati, Rohnert Park, Sonoma State University", "67686B"],
  ["sonoma", "10T", "10T", "10T - Cotati, Rohnert Park Tripper", "67686B"],
  ["sonoma", "12", "12", "12 - Northern Rohnert Park", "24338A"],
  ["sonoma", "12T", "12T", "12T - Northern Rohnert Park Tripper", "24338A"],
  ["sonoma", "14", "14", "14 - Northern Rohnert Park", "AA0072"],
  ["sonoma", "20", "20", "20 - Russian River Area, Forestville, Sebastopol, Santa Rosa", "8F6D5D"],
  ["sonoma", "20X", "20X", "20X - Russian River Area, Santa Rosa", "8F6D5D"],
  ["sonoma", "24", "24", "24 - Sebastopol Shuttle", "DA1F3D"],
  ["sonoma", "26", "26", "26 - Sebastopol, Cotati, Rohnert Park", "840715"],
  ["sonoma", "28", "28", "28 - Guerneville, Monte Rio", "522E92"],
  ["sonoma", "30", "30", "30 - Santa Rosa, Sonoma Valley", "007363"],
  ["sonoma", "30X", "30X", "30X - Santa Rosa/Sonoma Valley", "007363"],
  ["sonoma", "32", "32", "32 - Sonoma Valley", "771473"],
  ["sonoma", "34", "34", "34 - Santa Rosa, Sonoma", "ED1163"],
  ["sonoma", "36", "36", "36 - Sonoma, Rohnert Park, Petaluma SRJC, Credo HS, SSU", "0CAFB6"],
  ["sonoma", "40x", "40x", "40x - Sonoma, Petaluma", "F26522"],
  ["sonoma", "42", "42", "42 - Santa Rosa, Industry West Business Park", "EC008C"],
  ["sonoma", "44", "44", "44 - Petaluma, JC, SSU, Santa Rosa", "747500"],
  ["sonoma", "48", "48", "48 - Santa Rosa, Rohnert Park, Cotati, Petaluma", "006FBA"],
  ["sonoma", "48X", "48X", "48X - Coddingtown/Petaluma Mall Express p-2756", "006FBA"],
  ["sonoma", "60", "60", "60 - Cloverdale, Healdsburg, Windsor, Santa Rosa", "9E489B"],
  ["sonoma", "60X", "60X", "60X - Cloverdale/Santa Rosa Express", "9E489B"],
  ["sonoma", "62", "62", "62 - Santa Rosa, County Airport", "27004B"],
  ["sonoma", "66", "66", "66 - Windsor Shuttle", "FEBE10"],
  ["sonoma", "67", "67", "67 - Healdsburg Shuttle", "009848"],
  ["sonoma", "68", "68", "68 - Cloverdale Shuttle", "0D96D4"],
  ["south-sf", "BLUE", "BLUE", "Free South City Shuttle - Blue", "293adb"],
  ["south-sf", "GREEN", "GREEN", "Free South City Shuttle-Green", "0e834d"],
  ["south-sf", "ORANGE", "ORANGE", "Free South City Shuttle-Green", "F5A623"],
  ["tri-delta", "200X", "200X", "Martinez / Pittsburg", "C09600"],
  ["tri-delta", "201X", "201X", "Pittsburg-Bay Point BART / Concord BART", "002580"],
  ["tri-delta", "360", "360", "Los Medanos College / Antioch High School", "785A33"],
  ["tri-delta", "362", "362", "Oakley Schools", "9E12C1"],
  ["tri-delta", "370", "370", "Pittsburg-Bay Point BART / Antioch BART", "D6393C"],
  ["tri-delta", "371", "371", "Pittsburg-Bay Point BART / Antioch BART", "3DADE4"],
  ["tri-delta", "372", "372", "Pittsburg-Bay Point BART/ Los Medanos College Pittsburg", "0E8955"],
  ["tri-delta", "373", "373", "Brentwood Park & Ride / Antioch BART", "FFA856"],
  ["tri-delta", "374", "374", "Pittsburg-Bay Point BART / Bay Point", "A03B00"],
  ["tri-delta", "375", "375", "Antioch BART / Slatten Ranch Center", "613FA6"],
  ["tri-delta", "376", "376", "Antioch BART / Kaiser Antioch Medical Center", "A72051"],
  ["union-city", "1", "1", "Delores", "F7DF45"],
  ["union-city", "2", "2", "Whipple", "23BE04"],
  ["union-city", "3 -> 4", "3 -> 4", "Almaden -> Tamarack", "0572E6"],
  ["union-city", "4 -> 3", "4 -> 3", "Tamarack -> Almaden", "F2854A"],
  ["union-city", "5", "5", "Dyer", "F20791"],
  ["union-city", "8", "8", "Alvarado-Niles", "8E3E8B"],
  ["vacaville", "2", "2", "Route 2", "C45911"],
  ["vacaville", "3", "3", "Route 3", "FF00FF"],
  ["vacaville", "4", "4", "Route 4", "00B050"],
  ["vacaville", "5", "5", "Route 5", "0070C0"],
  ["vacaville", "6", "6", "Route 6", "663300"],
  ["vine", "10", "10", "Up Valley Connector", "3195C9"],
  ["vine", "11", "11", "Napa-Vallejo Connector", "8D64AA"],
  ["vine", "11X", "11X", "Napa-Vallejo Express", "EB563B"],
  ["vine", "21", "21", "Napa-Solano Express", "65AD47"],
  ["vine", "29", "29", "Napa-BART Express", "DE386E"],
  ["vine", "A", "A", "Browns Valley", "984A2B"],
  ["vine", "ACTAM", "ACTAM", "AM - American Canyon Transit", "4D43DE"],
  ["vine", "ACTPM", "ACTPM", "PM - American Canyon Transit", "0D594F"],
  ["vine", "B", "B", "Westwood | South Napa", "231F20"],
  ["vine", "C", "C", "Jefferson | Central Napa", "D05BA2"],
  ["vine", "D", "D", "Shelter | Shurtleff", "FBD603"],
  ["vine", "E", "E", "Vintage", "E63127"],
  ["vine", "F", "F", "Southwest Napa", "E67425"],
  ["vine", "G", "G", "Coombs | South Napa", "00A49A"],
  ["vta-bus", "20", "20", "Milpitas BART - Sunnyvale TC", "29588c"],
  ["vta-bus", "21", "21", "Stanford Shopping Ctr - Santa Clara TC", "29588c"],
  ["vta-bus", "22", "22", "Palo Alto TC - Eastridge", "e4002b"],
  ["vta-bus", "23", "23", "De Anza Coll - Alum Rock via Stevens Crk", "e4002b"],
  ["vta-bus", "25", "25", "De Anza Coll - Alum Rock via Valley Med", "e4002b"],
  ["vta-bus", "26", "26", "West Valley Coll - Eastridge", "e4002b"],
  ["vta-bus", "27", "27", "Winchester Stn - Santa Teresa Stn", "29588c"],
  ["vta-bus", "31", "31", "Evergreen Valley Coll - Eastridge", "29588c"],
  ["vta-bus", "37", "37", "West Valley Coll - Capitol Stn", "29588c"],
  ["vta-bus", "39", "39", "Eastridge - The Villages", "29588c"],
  ["vta-bus", "40", "40", "Foothill Coll - Mtn View TC via N. Bayshore", "29588c"],
  ["vta-bus", "42", "42", "Evergreen Valley Coll - Santa Teresa Stn", "29588c"],
  ["vta-bus", "47", "47", "Milpitas BART - Alder Stn via McCarthy Ranch", "29588c"],
  ["vta-bus", "51", "51", "Moffett Field - West Valley Coll", "29588c"],
  ["vta-bus", "52", "52", "Foothill Coll - Mnt View TC via El Monte", "29588c"],
  ["vta-bus", "53", "53", "Sunnyvale TC - Santa Clara TC", "29588c"],
  ["vta-bus", "55", "55", "Old Ironsides Stn - De Anza Coll", "29588c"],
  ["vta-bus", "56", "56", "Lockheed Martin - Monterey & Old Tully", "29588c"],
  ["vta-bus", "57", "57", "Old Ironsides Stn - West Valley Coll", "e4002b"],
  ["vta-bus", "59", "59", "Valley Med - Baypointe via Alviso", "29588c"],
  ["vta-bus", "60", "60", "Milpitas BART - Winchester Stn via SJC Airport", "e4002b"],
  ["vta-bus", "61", "61", "Sierra & Piedmont - Good Samaritan Hospital", "e4002b"],
  ["vta-bus", "64A", "64A", "Ohlone-Chynoweth Stn - McKee & White", "e4002b"],
  ["vta-bus", "64B", "64B", "Almaden & Camden - Mckee & White", "e4002b"],
  ["vta-bus", "66", "66", "North Milpitas - Santa Teresa Stn", "e4002b"],
  ["vta-bus", "68", "68", "San Jose Diridon - Gilroy TC", "e4002b"],
  ["vta-bus", "70", "70", "Milpitas BART - Capitol Stn via Jackson", "e4002b"],
  ["vta-bus", "71", "71", "Milpitas BART - Eastridge via White", "e4002b"],
  ["vta-bus", "72", "72", "Dtwn SJ - Senter & Monterey via McLaughlin", "e4002b"],
  ["vta-bus", "73", "73", "Dtwn SJ - Senter & Monterey via Senter", "e4002b"],
  ["vta-bus", "77", "77", "Milpitas BART - Eastridge via King", "e4002b"],
  ["vta-bus", "83", "83", "Ohlone-Chynoweth Stn - Almaden & McKean", "29588c"],
  ["vta-bus", "84", "84", "Gilroy TC - St. Louise Hosp via Gilroy Outlets", "29588c"],
  ["vta-bus", "85", "85", "Gilroy TC - St. Louise Hosp via West Gilroy", "29588c"],
  ["vta-bus", "86", "86", "Gavilan Coll - Gilroy TC", "29588c"],
  ["vta-bus", "87", "87", "Morgan Hill Civic Center - Burnett Ave", "29588c"],
  ["vta-bus", "89", "89", "California Ave Caltrain - Palo Alto VA Hosp", "29588c"],
  ["vta-bus", "200", "200", "Baypointe - Mountain View", "CC6600"],
  ["vta-bus", "201", "201", "2nd & Santa Clara - Santa Teresa", "007ACC"],
  ["vta-bus", "202", "202", "2nd & Santa Clara - Winchester", "379400"],
  ["vta-bus", "203", "203", "Civic Center - Baypointe - Alum Rock", "29588c"],
  ["vta-bus", "ACE Brown", "ACE Brown", "North San Jose", "6d4739"],
  ["vta-bus", "ACE Gray", "ACE Gray", "South Sunnyvale", "939598"],
  ["vta-bus", "ACE Green", "ACE Green", "North Santa Clara", "0e9972"],
  ["vta-bus", "ACE Orange", "ACE Orange", "Mountain View", "D96B1C"],
  ["vta-bus", "ACE Purple", "ACE Purple", "West Milpitas", "263996"],
  ["vta-bus", "ACE Red", "ACE Red", "North Sunnyvale", "d60e51"],
  ["vta-bus", "ACE Violet", "ACE Violet", "South Milpitas", "bbb7da"],
  ["vta-bus", "ACE Yellow", "ACE Yellow", "South Santa Clara", "ffe601"],
  ["vta-bus", "Bus Bridge", "Bus Bridge", "Hostetter - Alum Rock", "e4002b"],
  ["vta-bus", "Express 101", "Express 101", "Camden & Hwy 85 - Stanford Research Park", "379400"],
  ["vta-bus", "Express 102", "Express 102", "South San Jose - Stanford Research Park", "379400"],
  ["vta-bus", "Express 103", "Express 103", "Eastridge - Stanford Research Park", "379400"],
  ["vta-bus", "Express 104", "Express 104", "Milpitas BART - Stanford Research Park", "379400"],
  ["vta-bus", "Rapid 500", "Rapid 500", "San Jose Diridon - Berryessa BART", "e4002b"],
  ["vta-bus", "Rapid 522", "Rapid 522", "Palo Alto TC - Eastridge Rapid", "e4002b"],
  ["vta-bus", "Rapid 523", "Rapid 523", "San Jose State - Lockheed Martin via De Anza", "e4002b"],
  ["vta-bus", "Rapid 568", "Rapid 568", "Gilroy TC - San Jose Diridon", "e4002b"],
  ["vta-bus", "School 246", "School 246", "Milpitas HS - Yellowstone & Butano", "29588c"],
  ["vta-bus", "School 247", "School 247", "Milpitas HS - Landess & Park Victoria", "29588c"],
  ["vta-bus", "School 255", "School 255", "Fremont HS - Lawrence & Tasman", "29588c"],
  ["vta-bus", "School 256", "School 256", "Willow Glen HS - 1st & Keyes", "29588c"],
  ["vta-bus", "School 287", "School 287", "Live Oak HS - Monterey & San Martin", "29588c"],
  ["vta-bus", "School 288", "School 288", "Gunn HS - Middlefield & Colorado via Charlston", "29588c"],
  ["vta-bus", "School 288L", "School 288L", "Gunn HS - Louis & Fielding", "29588c"],
  ["westcat", "10", "10", "Gems and Birds", "88c96f"],
  ["westcat", "11", "11", "Crockett - Rodeo - Hercules", "1b8dc3"],
  ["westcat", "12", "12", "Trees and Flowers", "ed008c"],
  ["westcat", "15", "15", "Rodeo - Hercules (Viewpointe/North Shore Business Park)", "c0b831"],
  ["westcat", "16", "16", "Pinole Valley - Old Town Pinole - Richmond Parkway Transit Center", "017f3f"],
  ["westcat", "19", "19", "Hercules - Pinole - Richmond Parkway Transit Center - Hilltop Mall", "652d90"],
  ["westcat", "30Z", "30Z", "Hercules Transit Center - Martinez", "00a650"],
  ["westcat", "C3", "C3", "Hercules Transit Center - Pinole - Contra Costa College", "005baa"],
  ["westcat", "J", "J", "Hercules Transit Center - Pinole - Richmond - BART", "5aaa47"],
  ["westcat", "JPX", "JPX", "Hercules Transit Center - El Cerrito del Norte BART", "f68121"],
  ["westcat", "JX", "JX", "Hercules Transit Center - El Cerrito del Norte BART", "f68121"],
  ["westcat", "Lynx", "Lynx", "Rodeo/Hercules/San Francisco Transbay Terminal", "8b0305"],
  ["wheels", "1", "1", "Gleason/Hacienda", "BEB3D8"],
  ["wheels", "2", "2", "East Dublin", "D9CA16"],
  ["wheels", "3", "3", "Stoneridge", "397791"],
  ["wheels", "4", "4", "Central Dublin", "7B00D4"],
  ["wheels", "8", "8", "Hopyard", "DC81A7"],
  ["wheels", "10R", "10R", "Pleasanton - Livermore via Stanley", "EF4123"],
  ["wheels", "11", "11", "Greenville", "FAA61A"],
  ["wheels", "14", "14", "Pleasanton - Livermore via Outlets", "B5343E"],
  ["wheels", "15", "15", "Springtown", "36A2A7"],
  ["wheels", "18", "18", "Granada", "B1D355"],
  ["wheels", "20X", "20X", "Vasco", "00A1E4"],
  ["wheels", "30R", "30R", "Dublin - Livermore via College", "00AB4E"],
  ["wheels", "53", "53", "Stoneridge", "A066AA"],
  ["wheels", "54", "54", "Hacienda", "91CAB7"],
  ["wheels", "70X", "70X", "Pleasant Hill", "007A64"],
  ["wheels", "201", "201", "Tassajara Hills", "B06127"],
  ["wheels", "202", "202", "Positano Hills", "B06127"],
  ["wheels", "502", "502", "Boulevard", "B06127"],
  ["wheels", "503", "503", "Shannon Park", "B06127"],
  ["wheels", "580X", "580X", "Airway", "0066B3"],
  ["wheels", "601", "601", "Ruby Hill", "5E4595"],
  ["wheels", "602", "602", "Del Prado Park", "5E4595"],
  ["wheels", "603", "603", "Muirwood Park", "5E4595"],
  ["wheels", "604", "604", "Fairlands", "5E4595"],
  ["wheels", "605", "605", "Nielsen Park", "5E4595"],
  ["wheels", "606", "606", "Vintage Hills", "5E4595"],
  ["wheels", "607", "607", "Laguna Oaks", "5E4595"],
  ["wheels", "608", "608", "Nielsen Park", "5E4595"],
  ["wheels", "610", "610", "Fairlands", "5E4595"],
  ["wheels", "611", "611", "Ruby Hill", "5E4595"]
]
